import _ from 'lodash';
import React, { useEffect, useState } from 'react';
import { Button, Col, Input, Modal, ModalBody, ModalHeader, Row, Table } from 'reactstrap';
import { api, dateHelpers } from '../utils';

export default function POReviewModal({ po, toggleCallback, refreshCallback }) {
  const [data, setData] = useState([]);
  const [newFollowUpDate, setNewFollowUpDate] = useState(dateHelpers.formatDateForServer(po.nextReviewDate))
  const [newNote, setNewNote] = useState("");
  const [reviewId, setReviewId] = useState(po.reviewId);
  const [working, setWorking] = useState(false);

  useEffect(refreshData, [reviewId])

  function refreshData() {
    setWorking(true);
    api
      .fetch(`Purchasing/GetPOReviewDetails/${reviewId}`)
      .then(r => {
        if (r.data.success) {
          setData(r.data.message)
        } else {
          console.error(r.data.message);
        }
      })
      .catch(api.catchHandler)
      .finally(() => setWorking(false))
  }

  function onSave() {
    setWorking(true);
    const payload = {
      dto: {
        reviewId: reviewId,
        note: newNote,
        nextFollowUp: newFollowUpDate
      },
      itemNumber: po.itemNumber,
      poNumber: po.poNumber
    }
    api
      .post('Purchasing/SavePOReviewDetail', payload)
      .then(r => {
        if (r.data.success) {
          setNewNote("");
          if (reviewId === 0) {
            setReviewId(r.data.message.reviewId);
            refreshCallback();
          } else {
            refreshData();
          }
        }
      })
      .catch(api.catchHandler)
      .finally(() => setWorking(false))
  }

  return (
    <Modal isOpen={true} toggle={toggleCallback} size="lg">
      <ModalHeader toggle={toggleCallback}>
        Review PO Line Item
      </ModalHeader>
      <ModalBody>
        <Row>
          <Col xs={6} className="fw-bold text-end">PO Number:</Col>
          <Col xs={6}>{po.poNumber}</Col>
        </Row>
        <Row>
          <Col xs={6} className="fw-bold text-end">Item Number:</Col>
          <Col xs={6}>{po.itemNumber}</Col>
        </Row>
        <Row>
          <Col xs={6} className="fw-bold text-end">Orig Promised Date:</Col>
          <Col xs={6}>{dateHelpers.toLongDateString(po.lineOrigPromisedDate)}</Col>
        </Row>
        <Row>
          <Col xs={6} className="pt-1 fw-bold text-end">Next Follow Up:</Col>
          <Col xs={6}>
            <Input
              type="date"
              className="w-50"
              value={newFollowUpDate}
              onChange={e => setNewFollowUpDate(e.target.value)}
              disabled={working}
            />
          </Col>
        </Row>
        <Row className="pt-1">
          <Col xs={1} className="fw-bold text-end pt-2">Notes:</Col>
          <Col xs={11}>
            <Input
              type="text"
              value={newNote}
              maxLength="200"
              onChange={e => setNewNote(e.target.value)}
              disabled={working}
            />
          </Col>
        </Row>
        <Row className="my-3">
          <Col className="text-center">
            <Button
              className="shredButton me-3"
              disabled={working || _.isNil(newNote) || newNote.length === 0 || _.isNil(newFollowUpDate) || newFollowUpDate.length === 0}
              onClick={onSave}
            >
              Add Review
            </Button>
            <Button
              className="shredButton"
              onClick={toggleCallback}
            >
              Cancel
            </Button>
          </Col>
        </Row>
        <Table size="sm" striped>
          <thead>
            <tr>
              <th>Review<br />Date</th>
              <th>Reviewed By</th>
              <th>Next<br />Follow Up</th>
              <th>Note</th>
            </tr>
          </thead>
          <tbody>
            {_.map(data, (datum, idx) =>
              <tr key={`m_${idx}`}>
                <td>{dateHelpers.toLongDateString(datum.dateCreated)}</td>
                <td>{datum.username}</td>
                <td>{dateHelpers.toLongDateString(datum.nextFollowUp)}</td>
                <td>{datum.note}</td>
              </tr>
            )}
          </tbody>
        </Table>
      </ModalBody>
    </Modal>
  );
}
